/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Type_Credit_NoteInputs */

const en_document_type_credit_note = /** @type {(inputs: Document_Type_Credit_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit note`)
};

/**
* | output |
* | --- |
* | "Credit note" |
*
* @param {Document_Type_Credit_NoteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const document_type_credit_note = /** @type {((inputs?: Document_Type_Credit_NoteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Type_Credit_NoteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_document_type_credit_note(inputs)
});